import React from 'react';
import SvgIcon from '@home/components/SvgIcon';
import './index.scss';
import { BubbleProps } from 'tea-component';
import BubbleCommon from '@op/components/BubbleCommon';

interface IRelatedHashtagsProps {
  /** 标签列表 */
  tags: string[];
  /** TikTok 标签链接前缀，默认为 TikTok */
  tagUrlPrefix?: string;
  /** 默认展示数量，默认为 10 */
  defaultVisibleCount?: number;
  /** 是否显示分享图标 */
  showShareIcon?: boolean;
  /** 自定义容器类名 */
  containerClassName?: string;
  /** 标签链接类名 */
  tagLinkClassName?: string;
  /** 气泡弹出层类名 */
  overlayClassName?: string;
  commonBubbleProps?: BubbleProps;
}

const RelatedHashtags: React.FC<IRelatedHashtagsProps> = ({
  tags,
  tagUrlPrefix = 'https://www.tiktok.com/tag/',
  defaultVisibleCount = 10,
  showShareIcon = false,
  containerClassName = '',
  tagLinkClassName = 'dbom-meme-detail-hashtag-link',
  overlayClassName = 'dbom-meme-detail-hashtag-bubble',
  commonBubbleProps = {},
}) => {
  if (!tags || tags.length === 0) {
    return <span className='dbom-no-hashtag'>-</span>;
  }

  const visibleTags = tags.slice(0, defaultVisibleCount);
  const overflowCount = tags.length - defaultVisibleCount;
  const overflowTags = tags.slice(defaultVisibleCount);

  const renderTag = (tag: string, key: string | number) => {
    const formattedTag = tag.startsWith('#') ? tag : `#${tag}`;
    const tagWithoutHash = tag.replace(/^#/, '');

    return (
      <a
        key={key}
        className={tagLinkClassName}
        href={`${tagUrlPrefix}${tagWithoutHash}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {formattedTag}
        {showShareIcon && (
          <SvgIcon
            type="aigc-share"
            className="dbom-meme-detail-hashtag-icon"
          />
        )}
      </a>
    );
  };

  return (
    <div className={`dbom-meme-detail-hashtags ${containerClassName}`.trim()}>
      {visibleTags.map((tag, i) => renderTag(tag, i))}

      {overflowCount > 0 && (
        <BubbleCommon
          tipsMap={null}
          showIcon={false}
          content={
            <div className="dbom-meme-detail-hashtags">
              {overflowTags.map((tag, i) => renderTag(tag, i))}
            </div>
          }
          overlayClassName={overlayClassName}
          {...commonBubbleProps}
        >
          <div className={tagLinkClassName}>
            <span>+{overflowCount}</span>
          </div>
        </BubbleCommon>
      )}
    </div>
  );
};

export default RelatedHashtags;
